import { Menu } from "@mui/icons-material";
import { Box, Drawer, FormGroup, List, ListItem, ListItemButton, Stack, Switch, Typography } from "@mui/material";
import { useState } from "react";
import { useLocationWeatherContext } from "../contexts/LocationWeatherContext";
import { getDegreeTypeInStorage, setDegreeTypeInStorage } from "../services/localStorageService";


const LeftDrawer = () => {

  const [drawerOpenClose, setDrawerOpenClose] = useState(false);
  const { setDegreeType } = useLocationWeatherContext();

  const handleDegreeTypeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const degreeType = e.target.checked ? 'celsius' : 'fahrenheit';
    setDegreeTypeInStorage(degreeType);
    setDegreeType(degreeType);
  }

  const list = () => (
    <Box
      sx={{ width: 250 }}
      role="presentation"
      onClick={(e) => setDrawerOpenClose(false)}
    >
      <List>
        <ListItem key="degreeTypeSwitch" disablePadding>
          <ListItemButton>
            <FormGroup>
              <Stack direction="row" spacing={1} alignItems="center">
                <Typography>°F</Typography>
                <Switch
                  sx={{
                    "&.MuiSwitch-root .MuiSwitch-switchBase": {
                      color: "#1976d2"
                    },

                    "&.MuiSwitch-root .Mui-checked": {
                      color: "#1976d2"
                    }
                  }}
                  checked={getDegreeTypeInStorage() === 'celsius'}
                  onChange={(e) => handleDegreeTypeChange(e)} />
                <Typography>°C</Typography>
              </Stack>
            </FormGroup>
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );


  return (
    <>
      <Menu sx={{ fontSize: 50 }} onClick={(e) => setDrawerOpenClose(true)}></Menu>
      <Drawer open={drawerOpenClose} onClose={() => setDrawerOpenClose(false)} >
        {list()}
      </Drawer >
    </>
  );
}

export default LeftDrawer;